module.exports = __webpack_public_path__ + "img/lassen_header.d96b44fa.webp";